module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8C4HL"))).then(() => module.bundle.root('jnagv'));